import { Injectable } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import * as ExcelJS from 'exceljs';
import { ExportToExcelOptions, Section } from '../../shared/Interfaces/IExcel';
import { HelperService } from './helper.service';
import * as _ from 'lodash';
@Injectable({
  providedIn: 'root',
})
export class ExcelService {
  constructor(private _helperService: HelperService) { }
  exportToExcelJs1(exportToExcelOptions: ExportToExcelOptions) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet 1');
    // Add main heading if provided
    if (exportToExcelOptions.mainHeading) {
      const mainHeadingRow = worksheet.addRow([exportToExcelOptions.mainHeading]);
      mainHeadingRow.font = { bold: true, size: 18, color: { argb: 'ff000000' } };
      worksheet.addRow([]); // Add an empty row for spacing
    }

    // Function to add a section
    const addSection = (section: Section) => {
      // Add section heading
      if (section.heading.length) {
        const headingRow = worksheet.addRow(section.heading);
        headingRow.font = { bold: true, size: 14, color: { argb: 'ff000000' } };
      }

      // Display data as key-value pairs or in table format
      if (section.showAsKeyValue) {
        section.headers.forEach((header, index) => {
          const row = worksheet.addRow([header, section.data[index]]);
          row.getCell(1).font = { bold: true }; // Make key (header) bold
        });
      } else {
        const headerRow = worksheet.addRow(section.headers); // Add section headers
        if (this._helperService.hasValue(section.headerStyle)) {
          headerRow.eachCell((cell: any, colNumber: number) => {
            let font: any = {}
            for (let key in section.headerStyle) {
              let value = section?.headerStyle[key];
              if (key !== 'fgColor') {
                if (value) {
                  font[key] = value
                }
              }
            }
            cell.font = font;
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: section?.headerStyle?.fgColor }
            worksheet.getColumn(colNumber).width = 20;
          })
        }
        else
          headerRow.font = { bold: true, size: 12, color: { argb: 'ff000000' } };

        // Add nested headers dynamically (if present)
        if (section.nestedHeaders && section.nestedHeaders.length) {
          const emptySpace = Array(section.headers.length).fill(''); // Create empty cells for main headers
          const nestedHeaderRow = worksheet.addRow([...emptySpace, ...section.nestedHeaders]);
          nestedHeaderRow.font = { bold: true, size: 12, color: { argb: 'ff000000' } };
        }

        // Loop through each item in the data array
        section.data.forEach(item => {
          // Dynamically construct the main row based on section.headerKeyMapping
          const mainRowData = section.mainKeyMapping.map(key => _.get(item, key)); // Map data keys to headers
          const mainRow = worksheet.addRow(mainRowData); // Add dynamic main row

          // If the item has nested data
          if (item.nestedData && section.nestedHeaders && section.nestedKeyMapping) {
            item.nestedData.forEach(nestedItem => {
              // Create an array of nested row data based on nestedKeyMapping
              const nestedRow = section.nestedKeyMapping.map(key => nestedItem[key]);
              worksheet.addRow([...Array(section.headers.length).fill(''), ...nestedRow]);
            });
          }
          else if (item.nestedData && section.nestedKeyMapping) {
            item.nestedData.forEach(nestedItem => {
              const nestedRow = section.nestedKeyMapping.map(key => nestedItem[key]);
              worksheet.addRow([...Array(section.skipNestedColumn).fill(''), ...nestedRow]);
            });
          }
          // Add gap after each data row
          if (section?.dataRowGap > 0) {
            for (var i = 0; i < section?.dataRowGap; i++) {
              worksheet.addRow([]);
            }
          }
        });
      }

      worksheet.addRow([]); // Add gap after each section
    };

    // Loop through each section and add it to the worksheet
    exportToExcelOptions.sections.forEach(section => {
      addSection(section);
    });

    // Generate Excel file
    if (!exportToExcelOptions.blob) {
      workbook.xlsx.writeBuffer().then((buffer: ArrayBuffer) => {
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = exportToExcelOptions.fileName + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      });
      return false;
    }
    else {
      return this.exportToExcelFunc(workbook, exportToExcelOptions);
    }
  }
  async exportToExcelFunc(workbook, exportToExcelOptions): Promise<Blob | void> {
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    return blob;
  }

}
